import { render, staticRenderFns } from "./SpecialtyInfo.vue?vue&type=template&id=3718ed7a&"
import script from "./SpecialtyInfo.vue?vue&type=script&lang=js&"
export * from "./SpecialtyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports